import { render, staticRenderFns } from "./AdminNewRequest.vue?vue&type=template&id=4d8c126a&scoped=true&"
import script from "./AdminNewRequest.vue?vue&type=script&lang=js&"
export * from "./AdminNewRequest.vue?vue&type=script&lang=js&"
import style0 from "./AdminNewRequest.vue?vue&type=style&index=0&id=4d8c126a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8c126a",
  null
  
)

export default component.exports